import { AuxTabBar } from "@blk/aladdin-react-components-es";
import * as React from "react";
import "common/common.scss";
import { batch, useDispatch, useSelector } from "react-redux";
import { InsPrivateEquityBenchmarksContent } from "./insPrivateEquityBenchmarksContent";
import { InsPrivateEquityStandardContent } from "./insPrivateEquityStandardContent";
import { useRefreshOnUserSettingsChange } from "hooks/widget-data/user-settings/user-settings";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setSelectedTabUid } from "store/administration";
import "../administration.scss";
import "./ins-private-equity-benchmark.scss";
import { removeAllSelectedRow } from "store/grids";
import { getCurrentLocalTime } from "common/date-utils";
export const preqinBenchmarkStandardGrid = "preqin-benchmark-standard-grid";
export const insightResearchStandardGrid = "insight-research-standard-grid";
export const privateEquityIndicesCustomGrid = "private-equity-indices-custom-grid";
export const standardBenchmarksGrid = "standard-benchmarks-grid";
const standardBenchmarkTabUid = "standardBenchmarks";
const uploadedBenchmarkTabUid = "uploadedBenchmarks";
export const InsPrivateEquityBenchmarks = () => {
    const indicesLang = language.en.administration.marketDataAdministration.indices;
    const dispatch = useDispatch();
    useRefreshOnUserSettingsChange();
    const tabs = [
        {
            content: React.createElement(InsPrivateEquityStandardContent, { stateId: standardBenchmarksGrid }),
            label: indicesLang.equityBenchmarksTabs.standard,
            uid: standardBenchmarkTabUid
        },
        {
            content: React.createElement(InsPrivateEquityBenchmarksContent, { allowDelete: true, allowExport: true, allowImport: true, isCustom: true, stateId: privateEquityIndicesCustomGrid }),
            label: indicesLang.equityBenchmarksTabs.uploaded,
            uid: uploadedBenchmarkTabUid
        }
    ];
    const indicesSelectedTabUid = useSelector((state) => state.administration.commonState.selectedTabUid.privateEquityBenchmarks) ?? tabs[0]?.uid;
    const selectedTab = tabs.find((tab) => tab.uid === indicesSelectedTabUid);
    const selectRowId = (tabUid) => {
        batch(() => {
            dispatch(setSelectedTabUid({ page: "privateEquityBenchmarks", tabUid }));
            const gridsToClear = tabs.filter((tab) => tab.uid !== tabUid).map((tab) => tab.content.props.stateId);
            gridsToClear.forEach((gridId) => dispatch(removeAllSelectedRow(gridId)));
        });
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "pageHeader pageHeaderText" }, indicesLang.privateEquityBenchmarks.title),
        React.createElement("div", { className: "tabBarGroup" },
            React.createElement(AuxTabBar, { activeUid: indicesSelectedTabUid, tabType: "modern", onTabBarItemSelected: (event) => {
                    appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.NavigationInMarketDataMenu, properties: { LocalTimestamp: getCurrentLocalTime() } }, { selectedTab: event.detail.tab.label });
                    selectRowId(event.detail.tab.uid);
                }, widthType: "truncated", data: tabs }),
            React.createElement("div", { className: "tab-content", role: "tabpanel" }, selectedTab && selectedTab.content)));
};
